import { isRejectedWithValue } from '@reduxjs/toolkit';
import { axiosAuth } from '../helper/axios-auth';


export function validateUser(documentNumber: string) {
  return async () => {
    try {
      const axios = await axiosAuth();
      const response = await axios.get(`/namu/documentValidate/${documentNumber}`);

      if (response.status === 200) {
       return response.data;
      } else {
        throw new Error('User not found');
      }
    } catch (error) {
      console.log('Erro no serviço validateUser', error)
      return isRejectedWithValue(error);
    }
  };
}
